import { render, staticRenderFns } from "./ScopeOfPracticeGroupInformation.vue?vue&type=template&id=54fdaf98&scoped=true&"
import script from "./ScopeOfPracticeGroupInformation.vue?vue&type=script&lang=js&"
export * from "./ScopeOfPracticeGroupInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fdaf98",
  null
  
)

export default component.exports